export default __webpack_public_path__ + "static/media/software development.efd52196.png";